





















































import { Component, Vue } from 'vue-property-decorator';
import MpCookieBanner from '@/components/controls/mp-cookie-banner/MpCookieBanner.vue';
@Component({
  components: { MpCookieBanner }
})
export default class LoginAppLayout extends Vue {
  openUrl(url: string, target: string) {
    window.open(url, target);
  }
}
